<template>
  <div class="flex flex-col waiting-list-container space-y-3 relative">
    <h3 class="flex">
      <img
        :src="require('@/assets/images/ic-waiting-list.svg')"
        alt="Conciertos Wegow"
        class="w-5 mr-2"
      />
      {{
        isInWaitingList
          ? $t("wegow.purchase.inWaitingList")
          : $t("wegow.purchase.waitingList")
      }}
    </h3>
    <p>
      {{ $t("wegow.purchase.waitingListDescription1") }}
    </p>
    <p>
      {{ $t("wegow.purchase.waitingListDescription2") }}
    </p>
    <div v-if="buttonCondition" class="flex justify-center space-x-5 pt-1">
      <wegow-button
        background="opacity"
        :text="$t('wegow.purchase.acceptWaitingList')"
        color="topaz"
        type="button"
        @click="$emit('accept')"
      />
    </div>
    <div
      v-else-if="event.user.waiting_weswap"
      class="flex justify-center space-x-5 pt-1"
    >
      <wegow-button
        :text="$t('wegow.purchase.deleteWaitingList')"
        color="white"
        border="topaz"
        type="button"
        @click="$emit('delete')"
      />
    </div>
    <img
      :src="require('@/assets/images/ic-weswap-logo.png')"
      alt="weswap logo"
      class="h-5 absolute right-4 bottom-3"
    />
  </div>
</template>
<script setup>
import { computed, onUnmounted, ref } from "vue";
import WegowButton from "@/components/general/forms/WegowButton";
import { useEvent } from "@/composables/useEvent";

defineEmits("accept", "decline", "delete");
const { details: event } = useEvent();
const storageUser = ref(localStorage.getItem("wl-user"));

// Computed
const isInWaitingList = computed(() => {
  return event.value.user.waiting_weswap || storageUser.value;
});
const buttonCondition = computed(() => {
  return !event.value.user.waiting_weswap && !storageUser.value;
});

// Lifehooks
onUnmounted(() => {
  localStorage.removeItem("wl-user");
});
</script>

<style lang="scss" scoped>
.waiting-list-container {
  background-color: $inputLigthBackground;
  border-radius: 5px;
  padding: 18px 20px;
  h3 {
    font-size: 20px;
  }
  p {
    font-size: 12px;
  }
}
</style>
